<template>
<span v-tooltip="'The number of environments that fall under this application.'" class="is-flex flex-column align-items-center">
  <span class="is-flex">
    <icon icon="server"/>
    <span>{{ count }}</span>
  </span>
  <small>environments</small>
</span>
</template>
<script>
export default {
  props: {
    count: {
      type: Number,
      default: 0
    }
  }
}
</script>